import { startAiLoader, AI_FEATURE_LOADING_MESSAGES } from '~core/aiLoader';

export const startRemovebgLoader = ({ isBlurBg }) => {
  const loadingMessages = isBlurBg
    ? AI_FEATURE_LOADING_MESSAGES.BLUR_BG
    : AI_FEATURE_LOADING_MESSAGES.REMOVE_BG;

  const title = isBlurBg ? 'Sfoca Sfondo' : 'Rimuovi Sfondo';

  return startAiLoader(loadingMessages, `✨ ${title}`);
};
